import { render, staticRenderFns } from "./TestPayment.vue?vue&type=template&id=8efeedf4"
import script from "./TestPayment.vue?vue&type=script&lang=js"
export * from "./TestPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports